import React, { useRef, useState, useEffect } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { TextProps } from './../../view-models';

function TextComponent({ data, changeHandler }: TextProps) {
  const [text, setText] = useState<string | number>(data.value);
  const [error, setError] = useState<string>('');
  const id = data.id || 'text-' + Math.floor(Math.random() * 10000000);
  const style = data.style || { margin: 1, width: '90%' };
  const ref = useRef<null | ReturnType<typeof setTimeout>>(null);

  useEffect(() => {
    setText(data.value);
    !!data.required && data.value === '' ? setError('Should not be empty') : setError('');
  }, [data]);
  return (
    <FormControl sx={style} required={data.required}>
      <TextField
        id={id}
        error={data?.error || !!error}
        helperText={data?.helperText || error}
        label={data.label}
        variant="outlined"
        size="small"
        value={text}
        type={data?.type || 'textbox'}
        disabled={data?.disabled || false}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
          setText(event.target.value);
          if (ref.current) clearTimeout(ref.current);
          ref.current = setTimeout(() => {
            changeHandler(event || '');
          }, 500);
        }}
      />
    </FormControl>
  );
}

// export default withAITracking(reactPlugin, TextComponent);
export default TextComponent;
